import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'tab-bar',
    loadChildren: () => import('./tab-bar/tab-bar.module').then(m => m.TabBarPageModule)
  },
  {
    path: 'search',
    loadChildren: () => import('./body/search/search.module').then( m => m.SearchPageModule)
  },
  {
    path: 'order-place',
    loadChildren: () => import('./body/order-place/order-place.module').then( m => m.OrderPlacePageModule)
  },
  {
    path: '',
    redirectTo: 'tab-bar/tabs/home',
    pathMatch: 'full'
  },
  {
    path: 'splash',
    loadChildren: () => import('./startup/splash/splash.module').then( m => m.SplashPageModule)
  },
  {
    path: 'swiper',
    loadChildren: () => import('./startup/swiper/swiper.module').then( m => m.SwiperPageModule)
  },
  {
    path: 'cart',
    loadChildren: () => import('./body/cart/cart.module').then( m => m.CartPageModule)
  },
  {
    path: 'sign-in',
    loadChildren: () => import('./User_Authentication/sign-in/sign-in.module').then( m => m.SignInPageModule)
  },
  {
    path: 'loc',
    loadChildren: () => import('./body/loc/loc.module').then( m => m.LocPageModule)
  },
  {
    path: 'loc-modal',
    loadChildren: () => import('./body/loc-modal/loc-modal.module').then( m => m.LocModalPageModule)
  },
  {
    path: 'personal',
    loadChildren: () => import('./body/user/personal/personal.module').then( m => m.PersonalPageModule)
  },
  {
    path: 'bookmarks',
    loadChildren: () => import('./body/user/bookmarks/bookmarks.module').then( m => m.BookmarksPageModule)
  },
  {
    path: 'bot-chat',
    loadChildren: () => import('./body/user/bot-chat/bot-chat.module').then( m => m.BotChatPageModule)
  },
  {
    path: 'manage-payments',
    loadChildren: () => import('./body/user/manage-payments/manage-payments.module').then( m => m.ManagePaymentsPageModule)
  },
  {
    path: 'notifications',
    loadChildren: () => import('./body/user/notifications/notifications.module').then( m => m.NotificationsPageModule)
  },
  {
    path: 'offers',
    loadChildren: () => import('./body/offers/offers.module').then( m => m.OffersPageModule)
  },
  {
    path: 'orders',
    loadChildren: () => import('./body/user/orders/orders.module').then( m => m.OrdersPageModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('./body/user/settings/settings.module').then( m => m.SettingsPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
